module.exports = __webpack_public_path__ + "static/media/oneNote.c22feaa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/oneNote.png
// module id = 36
// module chunks = 0